import { createStore, createTypedHooks } from 'easy-peasy'
import tracking, { TrackingModel } from './models/tracking'

export interface StoreModel {
  tracking: TrackingModel
}

const model: StoreModel = {
  tracking
}

const store = createStore(model, {
  name: 'hvt-store',
})

export default store

export const { useStoreActions } = createTypedHooks<StoreModel>()
